import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LoadingSpinner } from '../../components'
import { getSessionPasswordless } from '../../utils/getSession'

export default function BrowsePasswordless() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      const error = searchParams.get('error')

      if (error) {
        const errorDescription = searchParams.get('error_description') || ''
        navigate(
          `/sso/browse/callback/error?error_description=${encodeURIComponent(errorDescription)}`,
          { replace: true },
        )
      } else {
        const checkout = searchParams.get('checkout')
        const redirectUrl = searchParams.get('redirect_url') || window.location.origin
        const basketId = searchParams.get('basket_id')
        if (basketId !== null) await getSessionPasswordless(basketId, checkout)
        window.location.replace(redirectUrl)
      }
    })()
  }, [])

  return (
    <div data-testid="browse-passwordless">
      <LoadingSpinner />
    </div>
  )
}
